import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';

export abstract class ApiBase {
  protected httpClient = inject(HttpClient);

  protected url(): string {
    return `${environment.apiUrl}/${this.endpoint}`;
  }

  protected urlCompanyOwn(): string {
    return `${environment.apiUrl}/companies/own/${this.endpoint}`;
  }

  abstract endpoint: string;
}
